var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHyphen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 217.557,
    height: 39.666,
    viewBox: "0 0 217.557 39.666",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30372",
    "data-name": "Group 30372",
    transform: "translate(13438 7777)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_141729",
    "data-name": "Path 141729",
    d: "M102.488,5.5,81.147,5.5V5.5H74.893a.168.168,0,0,0-.168.168V39.5a.168.168,0,0,0,.168.168h6.086a.168.168,0,0,0,.168-.168V30.042c4.383-.248,10.44-1.405,15.053-5.425,4.285-3.737,6.457-9.1,6.457-15.926V5.664a.169.169,0,0,0-.169-.168M91.975,20.359c-3.135,2.748-7.5,3.618-10.828,3.842V11.923H96.5a14.641,14.641,0,0,1-4.529,8.436",
    transform: "translate(-13438 -7777)",
    fill: "#0d1624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141730",
    "data-name": "Path 141730",
    d: "M138.108,37.829V5.674a.169.169,0,0,0-.168-.169h-6.127a.169.169,0,0,0-.168.169v16.2l-.013-.012c-5.145-4.474-12.051-5.333-16.337-5.374V5.674a.169.169,0,0,0-.168-.169H109a.169.169,0,0,0-.168.169V39.5a.168.168,0,0,0,.168.168h6.127a.168.168,0,0,0,.168-.168V22.958c3.282.034,8.5.643,12.117,3.8,2.789,2.443,4.217,6.166,4.233,11.062V39.5a.168.168,0,0,0,.168.168h6.127a.168.168,0,0,0,.168-.168V37.9l0,0c0-.025,0-.049,0-.074",
    transform: "translate(-13438 -7777)",
    fill: "#0d1624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141731",
    "data-name": "Path 141731",
    d: "M29.113,5.5H22.986v0a.168.168,0,0,0-.168.168V16.488c-4.286.041-11.193.9-16.338,5.374h0l-.01.01V5.67A.168.168,0,0,0,6.3,5.5H.169v0A.168.168,0,0,0,0,5.674V39.5a.168.168,0,0,0,.168.168H6.3a.168.168,0,0,0,.168-.168V37.617c.058-4.8,1.479-8.451,4.231-10.862,3.613-3.157,8.836-3.766,12.118-3.8V39.5a.168.168,0,0,0,.168.168h6.127a.168.168,0,0,0,.168-.168V5.67a.168.168,0,0,0-.168-.168",
    transform: "translate(-13438 -7777)",
    fill: "#0d1624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141732",
    "data-name": "Path 141732",
    d: "M169.733,11.785a.168.168,0,0,0,.168-.168V5.664a.168.168,0,0,0-.168-.168H144.451a.168.168,0,0,0-.168.168V39.5a.168.168,0,0,0,.168.168h25.282a.168.168,0,0,0,.168-.168V33.83a.168.168,0,0,0-.168-.168H150.794c.2-1.983,1.311-5.427,7.575-7.618a32.11,32.11,0,0,1,8.864-1.6.164.164,0,0,0,.16-.166l-.042-6.131v0a.167.167,0,0,0-.168-.166c-4.591.055-11.424,1.263-16.432,4.727V11.785Z",
    transform: "translate(-13438 -7777)",
    fill: "#0d1624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141733",
    "data-name": "Path 141733",
    d: "M68.373,5.5a20.973,20.973,0,0,0-15.218,6.67,22.377,22.377,0,0,0-1.467,1.73c-3.245-4.394-8.156-8.342-16.062-8.4a.173.173,0,0,0-.174.171V11.8a.167.167,0,0,0,.167.166c5.464.049,9.216,2.532,12.56,8.4a29.688,29.688,0,0,0-1.661,10.06V39.5a.168.168,0,0,0,.168.168h6.127a.168.168,0,0,0,.168-.168V30.432h0c0-9.128,5.291-18.366,15.4-18.466a.167.167,0,0,0,.166-.165V5.673a.173.173,0,0,0-.172-.172",
    transform: "translate(-13438 -7777)",
    fill: "#0d1624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141734",
    "data-name": "Path 141734",
    d: "M205.224,5.5H199.1l-.005,0a.168.168,0,0,0-.168.168V32.768c-5.54-.705-9.468-6.371-11.84-11.441a50.9,50.9,0,0,1-4.525-15.682.166.166,0,0,0-.165-.147h-.059l-.005,0h-6.085a.168.168,0,0,0-.168.168V39.5a.168.168,0,0,0,.168.168h6.085a.169.169,0,0,0,.169-.168V26.645c3.65,6.709,9,12.474,16.425,13.018h6.3a.168.168,0,0,0,.168-.168V5.67a.168.168,0,0,0-.168-.168",
    transform: "translate(-13438 -7777)",
    fill: "#0d1624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141735",
    "data-name": "Path 141735",
    d: "M211.057,3.566h-.6V.522h-1.309V0h3.216V.522h-1.309Z",
    transform: "translate(-13438 -7777)",
    fill: "#0d1624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141736",
    "data-name": "Path 141736",
    d: "M215.291,3.566l-.976-1.886c-.113-.321-.207-.6-.283-.869.019.315.032.655.032.919V3.566H213.5V0h.736l1.045,2.056c.132.365.151.409.252.742.126-.377.176-.516.251-.73L216.821.019h.736V3.566h-.566V1.731c0-.29.012-.592.031-.919-.1.34-.176.579-.308.919l-.955,1.835Z",
    transform: "translate(-13438 -7777)",
    fill: "#0d1624"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4764",
    "data-name": "Rectangle 4764",
    width: 217.557,
    height: 39.666,
    transform: "translate(-13438 -7777)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyphen);
export default __webpack_public_path__ + "static/media/Hyphen.0771291be4b6399bd0674a9cbb130179.svg";
export { ForwardRef as ReactComponent };